import React from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Trophy, UserPlus, X } from 'lucide-react';
import type { RealtimeEvent } from '../contexts/RealtimeContext';

interface NewLeadToastProps {
  toastId: string;
  visible: boolean;
  event: RealtimeEvent;
}

// Toast exibido quando um novo cliente chega em tempo real
const NewLeadToast: React.FC<NewLeadToastProps> = ({ toastId, visible, event }) => {
  const navigate = useNavigate();
  const Icon = event.won ? Trophy : UserPlus;

  const handleOpen = () => {
    toast.dismiss(toastId);
    navigate(event.link || '/admin/leads');
  };

  return (
    <div
      className={`w-[22rem] max-w-[calc(100vw-2rem)] bg-white rounded-xl shadow-lg border border-tinta/10 flex items-start gap-3 p-3 font-body transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
      }`}
    >
      <button onClick={handleOpen} className="flex flex-1 items-start gap-3 text-left min-w-0">
        <div className={`h-10 w-10 flex-shrink-0 rounded-full flex items-center justify-center ${event.won ? 'bg-mostarda/20' : 'bg-bordo/10'}`}>
          <Icon className={`h-5 w-5 ${event.won ? 'text-mostarda-dark' : 'text-bordo'}`} />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-bold text-tinta truncate">{event.title}</p>
          <p className="text-sm text-tinta-soft truncate">{event.body}</p>
          <p className="text-xs text-bordo font-semibold mt-0.5">Ver clientes</p>
        </div>
      </button>
      <button
        onClick={() => toast.dismiss(toastId)}
        className="p-1 rounded-md text-tinta-soft/60 hover:text-tinta hover:bg-creme-light"
        aria-label="Fechar"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default NewLeadToast;
